export enum ApiNotificationType {
  Manual = 0,
  LetterReceived = 1,
  LetterForwarded = 2,
  ArticleAssigned = 3,
  ReminderAssigned = 4,
  ReminderDue = 5,
}

export interface EmployeeNotificationListItemDto {
  id: number
  title: string
  body: string
  type: ApiNotificationType
  sentAt: string | null
  /** Some API responses may use createdAt instead of sentAt */
  createdAt?: string | null
  readAt: string | null
}

export type PaginatedEmployeeNotificationsDto = Paginated<
  EmployeeNotificationListItemDto[]
>

export interface LatestEmployeeNotificationDto {
  id: number
  title: string
  body: string
  sentAt: string | null
  createdAt?: string | null
  readAt: string | null
}
